import { render, staticRenderFns } from "./hyCol.vue?vue&type=template&id=2f1718e6&"
import script from "./hyCol.vue?vue&type=script&lang=js&"
export * from "./hyCol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.7.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports